import { Array, Boolean, Record, String, Unknown } from 'runtypes';

export const MessageListExtrasRunType = Record({
	hasMultipleReceivers: Boolean,
	otherReceiversOfThisMessage: Array(Unknown).Or(String),
});
